import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import {
  Card,
  FormHelperText,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import CustomSelect from "../../../../components/Select/Select";
import {
  addTaskByPatientId,
  deleteTasksByIds,
  getClinicFacilitiesWoLoader,
  getClinicStocksWoLoader,
  getInpatientById,
  getServicesWoLoader,
  updatePatientTaskActiveStatusById,
  updatePatientTaskStatusById,
} from "../../../../redux/reducers/clinicSlice";
import { storeAdmissionDetailsScreenDetails } from "../../../../redux/reducers/mixedSlice";
import {
  createDiagnosticsWoLoader,
  createProcedure,
  createProcedureWoLoader,
  getPetsCompliantSummaryWoLoader,
  updateProcedureByIdWoLoader,
} from "../../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../../redux/reducers/vetSlice";
import { AppColors } from "../../../../util/AppColors";
import { reasonList } from "../../../../util/arrayList";
import { addIcon } from "../../../../util/CommonIconStyle";
import {
  diagnosticTypes,
  diagStatusList,
  doneAtList,
  numberOfDaysList,
  priorityList,
  radioYesNoList,
  routeList,
  yesNoBoolList,
} from "../../../../util/dropList";
import {
  datePlusOneDay,
  filterRecordByHour,
  getActualTasks,
  getPlanListNew,
  getProcedureDetailsNew,
  getRightPackageUom,
  getTimeSlotsBasedOnTasks,
} from "../../../../util/function";
import FilesWithCloseButton from "../PatientWorkbook/FilesWithCloseButton";
import "./InpatientTasks.css";

const cardSty = {
  borderRadius: 3,
  padding: 1,
  borderTopColor: AppColors.appPrimary,
  marginLeft: 0.5,
  marginRight: 0.5,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
};
const cardIcon = { width: 30, height: 30, color: AppColors.appPrimary };
const initOpen = {
  procedure: true,
  adminster: true,
  diagnostics: true,
  others: true,
};
const initPlan = {
  task: null,
  // assignTo: null,
  repeatTask: false,
  noOfTimes: null,
  startDate: new Date(),
  endDate: new Date(),
  startTime: new Date(),
  endTime: new Date(),
  serviceId: null,
  productId: null,
  durationType: "Till Discharge",
  duration: null,
  active: true,
  taskType: "main",
};
const initPlans = {
  procedure: [],
  adminster: [],
  diagnostics: [],
  others: [{ ...initPlan, task: "Patient Update", i: 0 }],
};
const initDiag = {
  type: "Lab",
  testName: null,
  dueDate: new Date(),
  remarks: "",
  files: [],
  price: 0,
  tax: 0,
  sampleCollected: false,
  doneAt: doneAtList?.[0]?.value,
  collectionTime: new Date(),
  priority: "Routine",
  status: "In Progress",
};
const initDiagErrs = { type: false, dueDate: false, remarks: false };
const initDiagHlps = { type: "", dueDate: "", remarks: "" };
const nameExpan = {
  type: "Select Type",
  testName: "Test Name",
  variant: "Variant",
  dueDate: "Due Date",
  remarks: "Remarks",
  doneAt: "Done At",
  sampleType: "Sample Type",
  processingTime: "Processing Time",
  modality: "Modality",
  device: "Device",
  priority: "Priority",
  status: "Status",
  collectionTime: "Collection Time *",
  description: "Description",
};

const InpatientTasks = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [planModVsble, setPlanModVsble] = useState(false);
  const [planList, setPlanList] = useState(initPlans);
  const [openValues, setOpenValue] = useState(initOpen);
  const [planError, setPlanError] = useState(false);
  const [diagModVsble, setDiagModVsble] = useState(false);
  const [diagValues, setDiagValues] = useState(initDiag);
  const [diagnosticsHelpers, setDiagnosticsHelpers] = useState(initDiagHlps);
  const [diagnosticsErrors, setDiagnosticsErrors] = useState(initDiagErrs);
  const [patOtherModVsble, setPatOtherModVsble] = useState(false);
  const [patOtherValues, setPatOtherValues] = useState({});
  const [selectedTask, setSelectedTask] = useState(null);
  const [warnModVsble, setWarnModVsble] = useState(false);
  const [admUpdteModVsble, setAdmUpdteModVsble] = useState(false);
  const [adminValues, setAdminValues] = useState({});
  const [isPlanEdit, setPlanEdit] = useState(false);
  const [remarksModVsble, setRemarksModVsble] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [discontinueModVsble, setDiscontinueModVsble] = useState(false);
  const {
    services,
    clinicStocks,
    inpatientDetails,
    details: clinicDet,
    facilities,
  } = useSelector((state) => state?.clinic);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    dispatch(getServicesWoLoader());
    dispatch(getClinicStocksWoLoader());
    dispatch(getClinicVets());
    dispatch(getClinicFacilitiesWoLoader());
    onApiCall();
  }, []);

  useEffect(() => {
    onApiCall();
  }, [selectedDate]);

  const onApiCall = () => {
    dispatch(
      getInpatientById({
        inpatientId: apntDet?.patientId,
        url: `?date=${moment(new Date(selectedDate)).format("YYYY-MM-DD")}`,
      })
    );
    dispatch(
      getPetsCompliantSummaryWoLoader(apntDet?.appointment?.appointmentId)
    );
    dispatch(
      storeAdmissionDetailsScreenDetails({
        inpatientId: apntDet?.patientId,
        date: new Date(selectedDate),
      })
    );
  };

  const handleDateChange = (value) => {
    const reqDate = new Date(selectedDate);
    reqDate.setDate(
      value === "add" ? reqDate.getDate() + 1 : reqDate.getDate() - 1
    );
    setSelectedDate(reqDate);
  };

  const getStatusBadge = (tsk) => {
    const [hour, min] = tsk?.startTime?.split(":");
    const reqDate = new Date(new Date(selectedDate).setHours(hour, min));
    const isTimeExceed = new Date().getTime() > reqDate.getTime();
    if (tsk?.status === "true") {
      return (
        <div className="status-badge completed">
          <Typography className="fs10 white-color font-medium">
            Completed
          </Typography>
        </div>
      );
    }
    if (tsk?.status === "false") {
      return (
        <div className="status-badge pending">
          <Typography className="fs10 white-color font-medium">
            Not Done
          </Typography>
        </div>
      );
    }
    if (isTimeExceed) {
      return (
        <div className="status-badge overdue">
          <Typography className="fs10 white-color font-medium">
            Overdue
          </Typography>
        </div>
      );
    }
  };

  const onClosePlanMod = () => {
    setPlanEdit(false);
    setPlanModVsble(false);
    setPlanList(initPlans);
    setOpenValue(initOpen);
  };

  const handleOpenValues = (name, value) => {
    setOpenValue((prev) => ({ ...prev, [name]: value }));
  };

  const getAdministerList = () => {
    const reqList = clinicStocks?.data?.filter((dta) => {
      return (
        (dta?.category?.toLowerCase() === "deworming" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "flea & tick treatment" ||
          dta?.category?.toLowerCase() === "fluid therapy" ||
          dta?.category?.toLowerCase() === "grooming & hygiene care" ||
          dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "nutrition and supplements" ||
          dta?.category?.toLowerCase() === "other parasite treatment" ||
          dta?.category?.toLowerCase() === "vaccines") &&
        !planList?.adminster?.some((pl) => pl?.stockId === dta?.stockId)
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const onPrdChange = (name, value, ind, addObj) => {
    const planObj = { ...planList };
    const reqList = planList?.procedure?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "task" && addObj) {
          reqObj.stockId = addObj?.stockId;
          reqObj.productId = addObj?.productId;
          reqObj.serviceId = addObj?.serviceId;
        }
        return reqObj;
      }
      return pl;
    });
    planObj.procedure = reqList;
    setPlanList(planObj);
  };

  const onAdmChange = (name, value, ind, addObj) => {
    const planObj = { ...planList };
    const reqList = planList?.adminster?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "task" && addObj) {
          reqObj.stockId = addObj?.stockId;
          reqObj.productId = addObj?.productId;
          reqObj.serviceId = addObj?.serviceId;
        }
        return reqObj;
      }
      return pl;
    });
    planObj.adminster = reqList;
    setPlanList(planObj);
  };

  const onDiagChange = (name, value, ind, addObj) => {
    const planObj = { ...planList };
    const reqList = planList?.diagnostics?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "task" && addObj) {
          reqObj.stockId = addObj?.stockId;
          reqObj.productId = addObj?.productId;
          reqObj.serviceId = addObj?.serviceId;
          if (addObj?.serviceId) {
            reqObj.variant = getVariantsByServiceId(
              addObj?.serviceId
            )?.[0]?.variantId;
          }
        }
        return reqObj;
      }
      return pl;
    });
    planObj.diagnostics = reqList;
    setPlanList(planObj);
  };

  const onOtherChange = (name, value, ind, addObj) => {
    const planObj = { ...planList };
    const reqList = planList?.others?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "task" && addObj) {
          reqObj.stockId = addObj?.stockId;
          reqObj.productId = addObj?.productId;
          reqObj.serviceId = addObj?.serviceId;
        }
        return reqObj;
      }
      return pl;
    });
    planObj.others = reqList;
    setPlanList(planObj);
  };

  const onAddItem = (name) => {
    const planObj = { ...planList };
    planObj[name] = [
      ...(planObj[name] ?? []),
      { ...initPlan, i: planObj[name]?.length ?? 0, isEdit: true },
    ];
    setPlanList(planObj);
  };

  const getUserNameById = (id) => {
    const vetMatch = clinicVets?.find((vet) => vet?.doctorId === id);
    const clinicMatch = clinicDet?.id === id;
    return vetMatch ? vetMatch?.name : clinicMatch ? clinicDet?.name : "";
  };

  const getVets = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const deletePrdItem = (ind) => {
    const planObj = { ...planList };
    planObj.procedure = planObj?.procedure?.filter((pl, i) => i !== ind);
    setPlanList(planObj);
  };

  const deleteAdmItem = (ind) => {
    const planObj = { ...planList };
    planObj.adminster = planObj?.adminster?.filter((pl, i) => i !== ind);
    setPlanList(planObj);
  };

  const deleteDiagItem = (ind) => {
    const planObj = { ...planList };
    planObj.diagnostics = planObj?.diagnostics?.filter((pl, i) => i !== ind);
    setPlanList(planObj);
  };

  const deleteOthetItem = (ind) => {
    const planObj = { ...planList };
    planObj.others = planObj?.others?.filter((pl, i) => i !== ind);
    setPlanList(planObj);
  };

  const isInvalidPlan = (pl) => {
    return (
      pl?.category === null ||
      pl?.task === null ||
      pl?.task === "" ||
      (pl?.repeatTask ? pl?.noOfTimes === "" || !pl?.noOfTimes : false) ||
      (pl?.durationType === "Duration"
        ? pl?.duration === "" || !pl?.duration
        : false)
    );
  };

  const getReqService = (serviceId) => {
    return services?.data?.find((li) => li?.serviceId === serviceId);
  };

  // Helper function to compare specific fields and detect changes
  const compareFields = (current, oldObjStr) => {
    if (!oldObjStr) return null; // No old object means it's a new item

    try {
      const oldObj = JSON.parse(oldObjStr);
      const changes = {};

      // Fields to compare
      const fieldsToCompare = [
        "category",
        "task",
        "startTime",
        "endTime",
        "repeatTask",
        "noOfTimes",
        "stockId",
        "serviceId",
        "durationType",
        "duration",
        "variant",
      ];

      // Helper to format time consistently for comparison - only HH:mm
      const formatTimeForComparison = (val) => {
        if (!val) return null;

        // If already in HH:mm format, return as is
        if (typeof val === "string" && val.match(/^\d{2}:\d{2}$/)) {
          return val;
        }

        // If it's a Date object, extract HH:mm
        if (val instanceof Date) {
          return moment(val).format("HH:mm");
        }

        // Try to parse as Date and extract HH:mm
        try {
          const dateObj = new Date(val);
          if (!isNaN(dateObj.getTime())) {
            return moment(dateObj).format("HH:mm");
          }
        } catch (e) {
          // If parsing fails, try to extract HH:mm from string if it contains time
          if (typeof val === "string") {
            const timeMatch = val.match(/(\d{2}):(\d{2})/);
            if (timeMatch) {
              return `${timeMatch[1]}:${timeMatch[2]}`;
            }
          }
        }

        return null;
      };

      fieldsToCompare.forEach((field) => {
        let oldVal = oldObj[field];
        let currVal = current[field];

        // Handle time fields specially
        if (field === "startTime" || field === "endTime") {
          oldVal = formatTimeForComparison(oldVal);
          currVal = formatTimeForComparison(currVal);
        }

        // Normalize values for comparison (handle null/undefined)
        const oldStr =
          oldVal === null || oldVal === undefined ? null : String(oldVal);
        const currStr =
          currVal === null || currVal === undefined ? null : String(currVal);

        if (oldStr !== currStr) {
          changes[field] = {
            original: oldVal,
            changed: currVal,
          };
        }
      });

      return Object.keys(changes).length > 0 ? changes : null;
    } catch (e) {
      console.error("Error parsing oldObj:", e);
      return null;
    }
  };

  const handleSubmit = () => {
    if (
      (planList?.procedure?.length === 0 &&
        planList?.adminster?.length === 0 &&
        planList?.diagnostics?.length === 0 &&
        planList?.others?.length === 0) ||
      (planList?.procedure?.some(isInvalidPlan) &&
        planList?.adminster?.some(isInvalidPlan) &&
        planList?.diagnostics?.some(isInvalidPlan) &&
        planList?.others?.some(isInvalidPlan))
    ) {
      return setPlanError(true);
    }
    const mainTaskList = [];
    const changedItemsList = []; // Track items with changes
    planList?.procedure?.forEach((item) => {
      const oldObjStr = item?.oldObj;
      const currentItem = { ...item };
      delete currentItem.oldObj;

      // Check for changes in specific fields
      const fieldChanges = compareFields(currentItem, oldObjStr);
      const isNewItem = !item?.isAlreadyExists;
      const hasChanges = fieldChanges !== null;

      // Include if it's a new item (!isAlreadyExists) or has changes
      if (isNewItem || hasChanges) {
        const transformedItem = {
          ...currentItem,
          category: "procedure",
          task: currentItem?.task,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          startTime: moment(new Date(currentItem?.startTime)).format("HH:mm"),
          endTime: moment(
            new Date(
              currentItem?.repeatTask
                ? currentItem?.endTime
                  ? currentItem?.endTime
                  : currentItem?.startTime
                : currentItem?.startTime
            )
          ).format("HH:mm"),
          repeatTask: currentItem?.repeatTask,
          times: currentItem?.repeatTask ? currentItem?.noOfTimes ?? "1" : 0,
          stockId: currentItem?.stockId ?? null,
          serviceId: currentItem?.serviceId ?? null,
          durationType: currentItem?.durationType,
          duration:
            currentItem?.durationType === "Duration"
              ? currentItem?.duration ?? "1"
              : 0,
          taskType: "main",
          active: currentItem?.id ? currentItem?.active : true,
        };

        // Track changed items
        if (hasChanges || isNewItem) {
          changedItemsList.push({
            category: "procedure",
            id: currentItem?.id,
            task: currentItem?.task,
            isAlreadyExists: item?.isAlreadyExists || false,
            isNewItem: isNewItem,
            changes: fieldChanges,
            item: transformedItem,
          });
        }

        mainTaskList.push(transformedItem);
      }
    });
    planList?.adminster?.forEach((item) => {
      const oldObjStr = item?.oldObj;
      const currentItem = { ...item };
      delete currentItem.oldObj;

      // Check for changes in specific fields
      const fieldChanges = compareFields(currentItem, oldObjStr);
      const isNewItem = !item?.isAlreadyExists;
      const hasChanges = fieldChanges !== null;

      // Include if it's a new item (!isAlreadyExists) or has changes
      if (isNewItem || hasChanges) {
        const transformedItem = {
          ...currentItem,
          category: "adminster",
          task: currentItem?.task,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          startTime: moment(new Date(currentItem?.startTime)).format("HH:mm"),
          endTime: moment(
            new Date(
              currentItem?.repeatTask
                ? currentItem?.endTime
                  ? currentItem?.endTime
                  : currentItem?.startTime
                : currentItem?.startTime
            )
          ).format("HH:mm"),
          repeatTask: currentItem?.repeatTask,
          times: currentItem?.repeatTask ? currentItem?.noOfTimes ?? "1" : 0,
          stockId: currentItem?.stockId ?? null,
          serviceId: currentItem?.serviceId ?? null,
          durationType: currentItem?.durationType,
          duration:
            currentItem?.durationType === "Duration"
              ? currentItem?.duration ?? "1"
              : 0,
          taskType: "main",
          active: currentItem?.id ? currentItem?.active : true,
        };

        // Track changed items
        if (hasChanges || isNewItem) {
          changedItemsList.push({
            category: "adminster",
            id: currentItem?.id,
            task: currentItem?.task,
            isAlreadyExists: item?.isAlreadyExists || false,
            isNewItem: isNewItem,
            changes: fieldChanges,
            item: transformedItem,
          });
        }

        mainTaskList.push(transformedItem);
      }
    });
    planList?.diagnostics?.forEach((item) => {
      const oldObjStr = item?.oldObj;
      const currentItem = { ...item };
      delete currentItem.oldObj;

      // Check for changes in specific fields
      const fieldChanges = compareFields(currentItem, oldObjStr);
      const isNewItem = !item?.isAlreadyExists;
      const hasChanges = fieldChanges !== null;

      // Include if it's a new item (!isAlreadyExists) or has changes
      if (isNewItem || hasChanges) {
        const reqObj = {
          ...currentItem,
          category: "diagnostics",
          task: currentItem?.task,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          startTime: moment(new Date(currentItem?.startTime)).format("HH:mm"),
          endTime: moment(
            new Date(
              currentItem?.repeatTask
                ? currentItem?.endTime
                  ? currentItem?.endTime
                  : currentItem?.startTime
                : currentItem?.startTime
            )
          ).format("HH:mm"),
          repeatTask: currentItem?.repeatTask,
          times: currentItem?.repeatTask ? currentItem?.noOfTimes ?? "1" : 0,
          stockId: currentItem?.stockId ?? null,
          serviceId: currentItem?.serviceId ?? null,
          durationType: currentItem?.durationType,
          duration:
            currentItem?.durationType === "Duration"
              ? currentItem?.duration ?? "1"
              : 0,
          taskType: "main",
          active: currentItem?.id ? currentItem?.active : true,
          variant: currentItem?.variant ?? null,
        };
        const reqSer = getReqService(currentItem?.serviceId);
        const reqVarint =
          reqSer?.serviceVariants?.find(
            (li) => li?.variantId === currentItem?.variant
          ) ?? reqSer?.serviceVariants?.[0];
        reqObj.appId = apntDet?.appointment?.appointmentId ?? null;
        reqObj.type = reqSer?.category;
        reqObj.testName = currentItem?.task;
        reqObj.doneAt = doneAtList?.[0]?.value;
        reqObj.sampleCollected = false;
        reqObj.priority = "Routine";
        reqObj.price = reqVarint?.servicePrice;
        reqObj.tax = 0;
        reqObj.dueDate = moment(new Date()).format("YYYY-MM-DD");
        reqObj.remark = "";
        reqObj.variantId = currentItem?.variant;
        reqObj.variantName = reqVarint?.variantName;
        reqObj.addToBilling = false;
        reqObj.status = "Scheduled";

        // Track changed items
        if (hasChanges || isNewItem) {
          changedItemsList.push({
            category: "diagnostics",
            id: currentItem?.id,
            task: currentItem?.task,
            isAlreadyExists: item?.isAlreadyExists || false,
            isNewItem: isNewItem,
            changes: fieldChanges,
            item: reqObj,
          });
        }

        mainTaskList.push(reqObj);
      }
    });
    planList?.others?.forEach((item) => {
      const oldObjStr = item?.oldObj;
      const currentItem = { ...item };
      delete currentItem.oldObj;

      // Check for changes in specific fields
      const fieldChanges = compareFields(currentItem, oldObjStr);
      const isNewItem = !item?.isAlreadyExists;
      const hasChanges = fieldChanges !== null;

      // Include if it's a new item (!isAlreadyExists) or has changes
      if (isNewItem || hasChanges) {
        const transformedItem = {
          ...currentItem,
          category: "others",
          task: currentItem?.task,
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          startTime: moment(new Date(currentItem?.startTime)).format("HH:mm"),
          endTime: moment(
            new Date(
              currentItem?.repeatTask
                ? currentItem?.endTime
                  ? currentItem?.endTime
                  : currentItem?.startTime
                : currentItem?.startTime
            )
          ).format("HH:mm"),
          repeatTask: currentItem?.repeatTask,
          times: currentItem?.repeatTask ? currentItem?.noOfTimes ?? "1" : 0,
          stockId: currentItem?.stockId ?? null,
          serviceId: currentItem?.serviceId ?? null,
          durationType: currentItem?.durationType,
          duration:
            currentItem?.durationType === "Duration"
              ? currentItem?.duration ?? "1"
              : 0,
          taskType: "main",
          active: currentItem?.id ? currentItem?.active : true,
        };

        // Track changed items
        if (hasChanges || isNewItem) {
          changedItemsList.push({
            category: "others",
            id: currentItem?.id,
            task: currentItem?.task,
            isAlreadyExists: item?.isAlreadyExists || false,
            isNewItem: isNewItem,
            changes: fieldChanges,
            item: transformedItem,
          });
        }

        mainTaskList.push(transformedItem);
      }
    });
    const reqPlanList = getPlanListNew(
      {
        procedure: mainTaskList?.filter(
          (li) => li?.category?.toLowerCase() === "procedure"
        ),
        adminster: mainTaskList?.filter(
          (li) => li?.category?.toLowerCase() === "adminster"
        ),
        diagnostics: mainTaskList?.filter(
          (li) => li?.category?.toLowerCase() === "diagnostics"
        ),
        others: mainTaskList?.filter(
          (li) => li?.category?.toLowerCase() === "others"
        ),
      },
      services?.data ?? [],
      apntDet?.appointment?.appointmentId
    );
    if (mainTaskList?.filter((li) => li?.id)?.length > 0) {
      const taskToRemoveIds = [];
      mainTaskList
        ?.filter((li) => li?.id)
        ?.forEach((li) => {
          const subTaskList = apntDet?.inpatient?.tasks?.filter(
            (st) => st?.mainTaskId === li?.id
          );
          const now = new Date();
          // Convert each startDate + startTime → Date object,
          // then filter items that are in the future
          const upcomingList =
            subTaskList
              ?.filter((itm) => {
                const taskDateTime = new Date(
                  `${itm?.startDate}T${itm?.startTime}`
                );
                return taskDateTime > now;
              })
              ?.map((itm) => itm?.id) ?? [];
          taskToRemoveIds.push(...(upcomingList ?? []));
        });

      if (taskToRemoveIds?.length > 0) {
        dispatch(deleteTasksByIds({ ids: taskToRemoveIds }))
          .then((deleteRes) => {
            if (deleteRes?.payload) {
              // After successful deletion, proceed with adding tasks
              if (mainTaskList?.length === 0) {
                onApiCall();
                onClosePlanMod();
                return;
              }
              dispatch(
                addTaskByPatientId({
                  patientId: apntDet?.patientId,
                  data: reqPlanList,
                  // data: { tasks: mainTaskList },
                })
              ).then((res) => {
                if (res?.payload) {
                  onApiCall();
                  onClosePlanMod();
                }
              });
            }
          })
          .catch((error) => {
            console.error("Error deleting tasks:", error);
          });
      } else {
        // No tasks to delete, proceed directly with adding tasks
        if (mainTaskList?.length === 0) return onClosePlanMod();
        dispatch(
          addTaskByPatientId({
            patientId: apntDet?.patientId,
            data: reqPlanList,
            // data: { tasks: mainTaskList },
          })
        ).then((res) => {
          if (res?.payload) {
            onApiCall();
            onClosePlanMod();
          }
        });
      }
    } else {
      // No existing tasks to check, proceed directly with adding tasks
      if (mainTaskList?.length === 0) return onClosePlanMod();
      dispatch(
        addTaskByPatientId({
          patientId: apntDet?.patientId,
          data: reqPlanList,
          // { tasks: mainTaskList },
        })
      ).then((res) => {
        if (res?.payload) {
          onApiCall();
          onClosePlanMod();
        }
      });
    }
  };

  const getProcedureList = () => {
    return services?.data
      ?.filter(
        (li) =>
          (li?.category?.toLowerCase() !== "radiology" ||
            li?.category?.toLowerCase() !== "lab") &&
          !planList?.procedure?.some((pl) => pl?.serviceId === li?.serviceId)
      )
      ?.map((dta) => {
        return {
          ...dta,
          name: dta?.serviceName,
          value: dta?.serviceName,
        };
      });
  };

  const getDiagnosticsList = () => {
    return services?.data
      ?.filter(
        (li) =>
          (li?.category?.toLowerCase() === "radiology" ||
            li?.category?.toLowerCase() === "lab") &&
          !planList?.diagnostics?.some((pl) => pl?.serviceId === li?.serviceId)
      )
      ?.map((dta) => {
        return {
          ...dta,
          name: dta?.serviceName,
          value: dta?.serviceName,
        };
      });
  };

  const getServiceDetById = (servId, vrntId = null) => {
    const reqServ = services?.data?.find((ser) => ser?.serviceId === servId);
    if (vrntId) {
      return (
        reqServ?.serviceVariants?.find((vnt) => vnt?.variantId === vrntId) ?? {}
      );
    }
    return reqServ;
  };

  const getVariantsByServiceId = (servId = null) => {
    if (!servId) return [];
    const servDet = getServiceDetById(servId);
    if (servDet) {
      return servDet?.serviceVariants?.map((vnt) => ({
        ...vnt,
        name: vnt?.variantName,
        value: vnt?.variantId,
      }));
    }
    return [];
  };

  const onCloseRemarksMod = () => {
    setRemarksModVsble(false);
    setRemarks("");
    setSelectedTask(null);
  };

  const handleTaskCancel = (itm) => {
    setSelectedTask(itm);
    setRemarksModVsble(true);
  };

  const onSaveRemarks = () => {
    updateTaskStatus(selectedTask, false, remarks);
    onCloseRemarksMod();
  };

  const updateTaskStatus = async (itm, status, remarks = "") => {
    // if (itm?.category === "adminster" && itm?.stockId && status) {
    //   if (!apntDet?.procedures?.[0]?.procedureId) return setWarnModVsble(true);
    //   const reqStock = clinicStocks?.data?.find(
    //     (stc) => stc?.stockId === itm?.stockId
    //   );
    //   const isModalNeed = [
    //     "vaccines",
    //     "deworming",
    //     "flea & tick treatment",
    //   ].includes(reqStock?.category?.toLowerCase());
    //   if (isModalNeed && status) {
    //     setAdminValues({
    //       ...adminValues,
    //       name: reqStock?.productName,
    //       stockId: itm?.stockId,
    //       batchId: reqStock?.stockBatch?.[0]?.batchId,
    //       type: reqStock?.category,
    //       dosage: reqStock?.stockBatch?.[0]?.dosage ?? "1",
    //       route: routeList?.[0],
    //       serviceId: null,
    //       batchNumber: {
    //         name: reqStock?.stockBatch?.[0]?.batchNo,
    //         value: reqStock?.stockBatch?.[0]?.batchId,
    //         batchId: reqStock?.stockBatch?.[0]?.batchId,
    //         salesUom: reqStock?.stockBatch?.[0]?.salesUom,
    //         estCost: reqStock?.stockBatch?.[0]?.unitSellingPrice,
    //       },
    //       nextDueDate: datePlusOneDay,
    //     });
    //     setSelectedTask(itm);
    //     setAdmUpdteModVsble(true);
    //     return;
    //   } else {
    //     const reqObj = {
    //       detailId: null,
    //       stockId: itm?.stockId ?? null,
    //       batchId: reqStock?.stockBatch?.[0]?.batchId ?? null,
    //       type: "Administered",
    //       quantity: 1,
    //       status,
    //       remarks: "",
    //       estimatedCost: reqStock?.stockBatch?.[0]?.unitSellingPrice,
    //       name: reqStock?.productName,
    //       procedureName: reqStock?.name,
    //       dosage: reqStock?.stockBatch?.[0]?.dosage ?? "1",
    //       route: null,
    //       isDelete: false,
    //       serviceId: null,
    //     };
    //     dispatch(
    //       updateProcedureByIdWoLoader({
    //         id: apntDet?.procedures?.[0]?.procedureId,
    //         data: {
    //           serviceType: apntDet?.procedures?.[0]?.serviceType,
    //           appointmentId: apntDet?.appointment?.appointmentId,
    //           procedureDetails: [reqObj],
    //         },
    //       })
    //     );
    //   }
    // }
    if (itm?.category === "diagnostics" && status && itm?.serviceId) {
      const reqServ = getServiceDetById(itm?.serviceId);
      const reqObj = { ...diagValues, serviceId: itm?.serviceId };
      if (reqServ) {
        reqObj.type = reqServ?.category;
        reqObj.testName = reqServ?.serviceName;
        const reqVar = getVariantsByServiceId(reqServ?.serviceId)?.find(
          (vnt) => vnt?.variantId === Number(itm?.variant)
        );
        if (reqVar) {
          reqObj.variant = reqVar?.variantId;
          reqObj.variantName = reqVar?.variantName;
          reqObj.variantId = reqVar?.variantId;
          reqObj.price = reqVar?.servicePrice;
        }
      }
      setSelectedTask(itm);
      setDiagValues(reqObj);
      setDiagModVsble(true);
      return;
    }
    if (
      itm?.category?.toLowerCase() === "procedure" &&
      status &&
      itm?.serviceId
    ) {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === itm?.serviceId
      );
      const reqVar = reqServ?.serviceVariants?.[0];
      const procedureDetailsResult = await getProcedureDetailsNew({
        servId: reqServ?.serviceId ?? itm?.serviceId,
        varntId: reqVar?.variantId,
        serviceName: reqServ?.serviceName ?? itm?.task?.value,
        services: services?.data ?? [],
        clinicStocks: clinicStocks?.data ?? [],
        pharmacyTaxId: clinicDet?.pharmacyTaxId,
        status: true,
        facilities: facilities ?? [],
        facilityId: apntDet?.appointment?.facilityId ?? null,
      });
      const procedureDetails = procedureDetailsResult?.procedureDetails;
      const data = {
        procedureName: reqServ?.serviceName,
        serviceId: reqServ?.serviceId,
        category: reqServ?.category,
        subCategory: reqServ?.subCategory,
        remarks: "",
        doneAt: moment(new Date()).format("YYYY-MM-DD"),
        status: "Pending",
        petId: apntDet?.appointment?.petId,
        appointmentId: apntDet?.appointment?.appointmentId,
        serviceCharge: reqVar?.serviceCharge,
        serviceType: reqVar?.variantName,
        procedureDetails,
      };
      await dispatch(createProcedureWoLoader({ data }));
    }
    // if (
    //   itm?.category === "others" &&
    //   itm?.task === "Patient Update" &&
    //   status
    // ) {
    //   setSelectedTask(itm);
    //   setPatOtherModVsble(true);
    //   return;
    // }
    dispatch(
      updatePatientTaskStatusById({
        taskId: itm?.id,
        url: `?status=${status}&remark=${remarks}`,
      })
    ).then((res) => {
      if (res?.payload) onApiCall();
    });
  };

  const handleModClose = () => {
    setDiagModVsble(false);
    setDiagValues(initDiag);
    setDiagnosticsErrors(initDiagErrs);
    setDiagnosticsHelpers(initDiagHlps);
  };

  const onClosePatOtherMod = () => {
    setPatOtherModVsble(false);
    setSelectedTask(null);
  };

  const handleImageRemove = (ind) => {
    const reqFiles = diagValues?.files?.filter((fl, i) => i !== ind);
    setDiagValues({ ...diagValues, files: reqFiles });
  };

  const handleImageOtherPatRemove = (ind) => {
    const reqFiles = patOtherValues?.files?.filter((fl, i) => i !== ind);
    setPatOtherValues({ ...patOtherValues, files: reqFiles });
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = diagValues?.files?.length > 0 ? [...diagValues?.files] : [];

    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setDiagValues({ ...diagValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onUploadFilePatOther = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      patOtherValues?.files?.length > 0 ? [...patOtherValues?.files] : [];

    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setPatOtherValues({ ...patOtherValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleChangeValues = (name, value, addObj) => {
    const reqObj = { ...diagValues, [name]: value };
    if (name === "testName") {
      reqObj.price = addObj?.price;
      reqObj.tax = addObj?.tax;
      reqObj.doneAt = addObj.doneAt;
    }
    if (name === "variant") {
      reqObj.variantId = addObj?.variantId;
      reqObj.variantName = addObj?.variantName;
    }
    if (addObj?.serviceId) {
      reqObj.serviceId = addObj?.serviceId;
      const reqVar = getVariantsByServiceId(addObj?.serviceId);
      if (reqVar?.[0]?.variantId) {
        reqObj.variantId = reqVar?.[0]?.variantId;
        reqObj.variantName = reqVar?.[0]?.variantName;
        reqObj.variant = reqVar?.[0]?.variantId;
      }
    }
    if (name === "sampleCollected" && value) {
      reqObj.dueDate = new Date();
      reqObj.collectionTime = new Date();
    }
    setDiagValues(reqObj);
    setDiagnosticsErrors({
      ...diagnosticsErrors,
      [name]:
        value?.length > 0 || typeof value === "number"
          ? false
          : name === "dueDate"
          ? false
          : name === "collectionTime"
          ? false
          : true,
    });
    setDiagnosticsHelpers({
      ...diagnosticsHelpers,
      [name]:
        value?.length > 0 || typeof value === "number"
          ? ""
          : name === "dueDate"
          ? ""
          : name === "collectionTime"
          ? ""
          : `${name === "type" ? "Type" : nameExpan?.[name]} is required`,
    });
  };

  const handleChangeValuesPatOther = (name, value) => {
    const reqObj = { ...patOtherValues, [name]: value };
    setPatOtherValues(reqObj);
  };

  const onSaveDiag = async () => {
    const form = new FormData();
    form.append("appId", inpatientDetails?.appointmentId);
    form.append("type", diagValues?.type);
    form.append("testName", diagValues?.testName);
    form.append("doneAt", diagValues?.doneAt);
    form.append("sampleCollected", diagValues?.sampleCollected);
    form.append("priority", diagValues?.priority);
    form.append("price", Number(diagValues?.price ?? 0));
    form.append("tax", Number(diagValues?.tax ?? 0));
    form.append(
      "dueDate",
      moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
    );
    form.append("remark", diagValues?.remarks);
    form.append("serviceId", diagValues?.serviceId);
    form.append("variantId", diagValues?.variant ?? diagValues?.variantId);
    form.append("variantName", diagValues?.variantName);
    if (
      apntDet?.appointment?.appointmentDate ===
      moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
    ) {
      form.append("addToBilling", true);
    }
    if (diagValues?.sampleCollected) {
      if (diagValues?.files?.length > 0) {
        const filePromises = diagValues?.files?.map(async (fle) => {
          if (fle?.file) {
            return fle?.file; // Local File
          }
        });
        const finalFiles = await Promise.all(filePromises);
        finalFiles?.forEach((file) => {
          form.append("file", file);
        });
      }
      form.append(
        "collectionTime",
        moment(new Date(diagValues?.collectionTime)).format("HH:mm")
      );
    }
    form.append("status", diagValues?.status);
    dispatch(
      createDiagnosticsWoLoader({
        appointmentId: inpatientDetails?.appointmentId,
        form,
        formData: true,
      })
    ).then((res) => {
      if (res?.payload) {
        handleModClose();
        dispatch(
          updatePatientTaskStatusById({
            taskId: selectedTask?.id,
            url: `?status=${true}`,
          })
        ).then((res) => {
          if (res?.payload) {
            onApiCall();
            setSelectedTask(null);
          }
        });
      }
    });
  };

  const onCloseAdmUpdteMod = () => {
    setAdmUpdteModVsble(false);
    setAdminValues({});
  };

  const getBatch = (stockId, batchId = null, retStock = false) => {
    if (!stockId) return null;
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId
    );
    if (retStock) return reqStock;
    if (!batchId) return null;
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const onChangeAdminModValue = (name, value, addObj) => {
    const reqObj = { ...adminValues, [name]: value };
    if (name === "name" && addObj) {
      reqObj.type = addObj?.type;
      reqObj.stockId = addObj?.stockId;
      if (!adminValues?.dosage && addObj?.stockId) {
        const reqBatch = clinicStocks?.data?.find(
          (stc) => stc?.stockId === addObj?.stockId
        )?.stockBatch?.[0];
        reqObj.batchNumber = {
          name: reqBatch?.batchNo,
          value: reqBatch?.batchId,
        };
      }
      if (adminValues?.dosage) {
        if (addObj?.stockId) {
          const reqBatch = clinicStocks?.data?.find(
            (stc) => stc?.stockId === addObj?.stockId
          )?.stockBatch?.[0];
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio =
            Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.batchId = reqBatch?.batchId;
          reqObj.estCost = reqPrice;
          reqObj.batchNumber = {
            name: reqBatch?.batchNo,
            value: reqBatch?.batchId,
          };
        }
      }
    }
    if (name === "batchNumber") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        value?.value ?? adminValues?.batchId
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio =
        Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = value?.value ? reqPrice : 0;
    }
    if (name === "status") {
      if (value) {
        reqObj.reason = "Completed";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "statusDrop") {
      reqObj.status = value;
      if (value) {
        reqObj.reason = "Completed";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "dosage") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        adminValues?.batchNumber?.value ?? adminValues?.batchId
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio = Number(value) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = reqPrice;
    }
    if (name === "linkToProcedure") {
      reqObj.serviceId = addObj?.serviceId;
      reqObj.variantId = addObj?.variantId;
    }
    setAdminValues(reqObj);
  };

  const getBatches = (stkId = null) => {
    if (!stkId) return [];
    const reqStock = clinicStocks?.data?.find((stc) => stc?.stockId === stkId);
    return reqStock?.stockBatch?.map((bat) => ({
      name: bat?.batchNo,
      value: bat?.batchId,
      estCost: bat?.unitSellingPrice,
    }));
  };

  const handleAdmImageRemove = (ind) => {
    const reqFiles = (adminValues?.files ?? [])?.filter((fl, i) => i !== ind);
    setAdminValues({ ...adminValues, files: reqFiles });
  };

  const onUploadAdmFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      adminValues?.files?.length > 0 ? [...adminValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setAdminValues({ ...adminValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onSaveAdminValues = () => {
    const reqObj = {
      detailId: null,
      stockId: adminValues?.stockId ?? null,
      batchId: adminValues?.batchNumber?.value ?? adminValues?.batchId ?? null,
      type: "Administered",
      quantity: 1,
      status: true,
      remarks: "",
      estimatedCost: adminValues?.batchNumber?.estCost,
      name: adminValues?.name,
      procedureName: adminValues?.name,
      dosage: adminValues?.dosage,
      route: adminValues?.route?.value ?? null,
      isDelete: false,
      serviceId: null,
    };
    dispatch(
      updateProcedureByIdWoLoader({
        id: apntDet?.procedures?.[0]?.procedureId,
        data: {
          serviceType: apntDet?.procedures?.[0]?.serviceType,
          appointmentId: apntDet?.appointment?.appointmentId,
          procedureDetails: [reqObj],
        },
      })
    ).then((res) => {
      if (res?.payload) {
        onCloseAdmUpdteMod();
        dispatch(
          updatePatientTaskStatusById({
            taskId: selectedTask?.id,
            url: `?status=${true}`,
          })
        ).then((res2) => {
          if (res2?.payload) onApiCall();
        });
        if (adminValues?.nextDosage === "Yes") {
          const reqVarnt = getVariantsByServiceId(
            apntDet?.procedures?.[0]?.serviceId
          )?.find(
            (li) => li?.variantName === apntDet?.procedures?.[0]?.serviceType
          );
          const data = {
            doneAt: moment(new Date(adminValues?.nextDueDate)).format(
              "YYYY-MM-DD"
            ),
            remarks: "",
            procedureDetails: [],
            serviceType: apntDet?.procedures?.[0]?.serviceType,
            isFromPreventive: true,
            procedureVariantId: reqVarnt?.variantId ?? null,
            procedureName: apntDet?.procedures?.[0]?.procedureName,
            serviceId: apntDet?.procedures?.[0]?.serviceId,
            category: apntDet?.procedures?.[0]?.category ?? "",
            subCategory: apntDet?.procedures?.[0]?.subCategory ?? "",
            petId: apntDet?.procedures?.[0]?.petId,
            status: "Pending",
          };
          dispatch(createProcedure({ data })).then((res2) => {
            if (res2?.payload) onApiCall();
          });
        }
      }
    });
  };

  const onSavePatOther = () => {
    // console.log("patOtherValues", patOtherValues);
    onClosePatOtherMod();
  };

  const getArrayObject = (li, i) => {
    const reqObj = {
      ...li,
      i,
      isAlreadyExists: true,
      isDiscontinued: !li?.active,
      startTime: new Date(
        `${moment().format("YYYY-MM-DD")}T${li?.startTime}:00`
      ),
      endTime: new Date(`${moment().format("YYYY-MM-DD")}T${li?.endTime}:00`),
      durationType: li?.durationType,
      duration: li?.duration,
      noOfTimes: li?.times,
      startDate: null,
      endDate: null,
      updatedUser: li?.updatedUser ?? null,
      updatedDate: li?.updatedDate ?? null,
      isEdit: true,
    };
    if (li?.category === "diagnostics") {
      reqObj.variant = li?.variant ? Number(li?.variant) : null;
    }
    reqObj.oldObj = JSON.stringify(reqObj);
    return reqObj;
  };

  const handleEditPlan = () => {
    const reqList = apntDet?.inpatient?.tasks
      ?.filter((li) => li?.taskType?.toLowerCase() === "main")
      ?.reduce((acc, item) => {
        const key = item?.category || "unknown";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});
    setPlanEdit(true);
    setPlanList({
      procedure:
        reqList?.procedure?.map((li, i) => getArrayObject(li, i)) ?? [],
      adminster:
        reqList?.adminster?.map((li, i) => getArrayObject(li, i)) ?? [],
      diagnostics:
        reqList?.diagnostics?.map((li, i) => getArrayObject(li, i)) ?? [],
      others: reqList?.others?.map((li, i) => getArrayObject(li, i)) ?? [],
    });
    setPlanModVsble(true);
  };

  const onDiscontinue = (itm) => {
    setSelectedTask(itm);
    setDiscontinueModVsble(true);
  };

  const onEdit = (itm) => {
    const reqPlanList = { ...planList };
    reqPlanList[itm?.category]?.forEach((pl) => {
      if (pl?.id === itm?.id) {
        pl.isEdit = true;
      }
    });
    setPlanList(reqPlanList);
  };

  const onCloseDiscontinueMod = () => {
    setDiscontinueModVsble(false);
    setSelectedTask(null);
  };

  const onConfirmDiscontinue = () => {
    const taskToRemoveIds = [];
    const subTaskList = apntDet?.inpatient?.tasks?.filter(
      (st) => st?.mainTaskId === selectedTask?.id
    );
    const now = new Date();
    // Convert each startDate + startTime → Date object,
    // then filter items that are in the future
    const upcomingList =
      subTaskList
        ?.filter((itm) => {
          const taskDateTime = new Date(`${itm?.startDate}T${itm?.startTime}`);
          return taskDateTime > now;
        })
        ?.map((itm) => itm?.id) ?? [];
    taskToRemoveIds.push(...(upcomingList ?? []));
    if (taskToRemoveIds?.length > 0) {
      dispatch(deleteTasksByIds({ ids: taskToRemoveIds }));
    }
    dispatch(
      updatePatientTaskActiveStatusById({
        taskId: selectedTask?.id,
        url: `?active=${false}`,
      })
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        const reqPlanList = { ...planList };
        reqPlanList[selectedTask.category]?.forEach((pl) => {
          if (pl.id === selectedTask.id) {
            pl.active = false;
            pl.isDiscontinued = true;
            pl.updatedUser = profile?.id;
            pl.updatedDate = new Date();
          }
        });
        setPlanList(reqPlanList);
        onCloseDiscontinueMod();
      }
    });
  };

  return (
    <>
      <div className="flex1-end mb20">
        <div className="flex-row pr20">
          {apntDet?.appointment?.appointmentStatus?.toLowerCase() !==
          "completed" ? (
            apntDet?.inpatient?.tasks?.length > 0 ? (
              <div>
                <CustomButton
                  text="Edit Plan"
                  smallBtn
                  onClick={handleEditPlan}
                />
              </div>
            ) : (
              <div>
                <CustomButton
                  text="Create Plan"
                  smallBtn
                  onClick={() => setPlanModVsble(true)}
                />
              </div>
            )
          ) : null}
        </div>
      </div>

      <div className="flex-row-ali-cen mb30">
        <div className="flex1-center">
          <div className="flex-row">
            <div className="flex-center">
              <NavigateBeforeOutlinedIcon
                className="calendar-arrow cursor"
                onClick={() => handleDateChange("minus")}
              />
              <Typography className="font-bold mh20 fs14">
                {moment(new Date(selectedDate)).format("MMMM DD, YYYY")}
              </Typography>
              <NavigateNextOutlinedIcon
                className="calendar-arrow cursor"
                onClick={() => handleDateChange("add")}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="timeline-container">
        <div className="timeline-line"></div>

        <div className="tasks-container">
          {getTimeSlotsBasedOnTasks(
            getActualTasks(inpatientDetails?.tasks)
          )?.map((tim) => {
            return (
              <div>
                <div className="flex-row mb10">
                  <div
                    className={
                      filterRecordByHour(
                        getActualTasks(inpatientDetails?.tasks),
                        tim
                      )?.find(
                        (task) =>
                          task?.startTime?.split(":")[0] ===
                          moment(new Date()).format("HH")
                      )
                        ? "tsk-red-dot"
                        : "tsk-gry-dot"
                    }
                  />
                  <div className="gray37 fs12 txt-semi-bold con-fit ml20 tsk-gry-time">
                    {tim}
                  </div>
                </div>
                {filterRecordByHour(
                  getActualTasks(inpatientDetails?.tasks),
                  tim
                )?.map((task, index) => (
                  <div key={task?.id} className="task-item">
                    <Card className="task-card">
                      <div className="task-header">
                        <div className="task-name">
                          <div className="task-icon">◆</div>
                          <Typography className="fs14 font-bold blue-color">
                            {task?.task}
                          </Typography>
                        </div>
                        {getStatusBadge(task)}
                      </div>

                      <div className="flex-row-between">
                        <div className="task-detail-row">
                          {/* <div>
                            <div className="task-detail-item">
                              <img
                                src={require("../../../../assets/images/png/steath.png")}
                                className="img-wh15"
                                alt="vet"
                              />
                              <Typography className="fs12 gray36 ml5">
                                Vet
                              </Typography>
                            </div>
                            <Typography className="fs12 txt-regular black mt3 ml3">
                              Dr.{" "}
                              {
                                clinicVets?.find(
                                  (vet) => vet?.doctorId === task?.doctorId
                                )?.name
                              }
                            </Typography>
                          </div> */}
                          <div>
                            <div className="task-detail-item">
                              <img
                                src={require("../../../../assets/images/png/clock.png")}
                                className="img-wh15"
                                alt="time"
                              />
                              <Typography className="fs12 gray36 ml5">
                                Time
                              </Typography>
                            </div>
                            <Typography className="fs12 txt-regular black mt3 ml3">
                              {task?.startTime}
                              {`${task?.endDate ? ` - ${task?.endTime}` : ""}`}
                            </Typography>
                          </div>
                          <div>
                            <div className="task-detail-item">
                              <img
                                src={require("../../../../assets/images/png/refresh.png")}
                                className="img-wh15"
                                alt="repeat"
                              />
                              <Typography className="fs12 gray36 ml5">
                                Repeat
                              </Typography>
                            </div>
                            <Typography className="fs12 txt-regular black mt3 ml3">
                              {task?.repeatTask ? "Yes" : "No"}
                            </Typography>
                          </div>
                        </div>
                        <div className="flex1-end">
                          <div className="w60Per flex-end">
                            <div>
                              {task?.status === "false" && (
                                <div>
                                  <Typography className="fs10 txt-regular black mt3 ml3">
                                    Reason: {task?.remark}
                                  </Typography>
                                </div>
                              )}
                              {task?.status !== "true" &&
                              task?.status !== "false" ? (
                                <div className="task-actions">
                                  <img
                                    src={require("../../../../assets/images/png/tick.png")}
                                    className="img-wh20 cursor"
                                    onClick={() => updateTaskStatus(task, true)}
                                  />
                                  <img
                                    src={require("../../../../assets/images/png/crossRed.png")}
                                    className="img-wh20 cursor ml10"
                                    onClick={() => handleTaskCancel(task)}
                                  />
                                </div>
                              ) : (
                                <div>
                                  <Typography className="fs10 txt-regular black mt3 ml3">
                                    Updated on:{" "}
                                    {moment(new Date(task?.updatedDate)).format(
                                      "DD MMM YYYY, HH:mm"
                                    )}
                                  </Typography>
                                  <Typography className="fs10 txt-regular black mt3 ml3">
                                    Updated by:{" "}
                                    {getUserNameById(task?.updatedUser)}
                                  </Typography>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
      <CustomModal
        open={planModVsble}
        onClose={onClosePlanMod}
        header={`${isPlanEdit ? "Edit" : "Create"} Plan`}
        modal
        modalWidth={95}
      >
        <div className="scroll-70vh pb30">
          <Card sx={cardSty} className="mt5">
            <div
              className="flex-row-ali-cen cursor"
              onClick={() =>
                handleOpenValues("procedure", !openValues?.procedure)
              }
            >
              {openValues?.procedure ? (
                <ArrowDropDownIcon sx={cardIcon} />
              ) : (
                <ArrowRightIcon sx={cardIcon} />
              )}
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs14 blue-color">
                  Procedure
                </Typography>
              </div>
            </div>
            {openValues?.procedure ? (
              <div className="flex-column">
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <div style={{ minWidth: 1450 }}>
                    <div className="flex-row-ali-cen mh10">
                      <div style={{ width: 250 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Task <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Repeat Task?
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          No. of Times
                        </Typography>
                      </div>
                      <div style={{ width: 200 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration Type
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Start Time
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          End Time
                        </Typography>
                      </div>
                      <div style={{ width: 250 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {planList?.procedure?.map((pl, ind) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${ind}_procedure`}
                        >
                          <div className="pr10" style={{ width: 250 }}>
                            <CustomSelect
                              list={getProcedureList()}
                              value={pl?.task}
                              addNewSelect
                              handleChange={(e) => {
                                onPrdChange("task", e?.value ?? e, ind, {
                                  stockId: e?.stockId ?? null,
                                  serviceId: e?.serviceId ?? null,
                                });
                              }}
                              disabled={pl?.isAlreadyExists}
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomSelect
                              list={yesNoBoolList}
                              value={pl?.repeatTask}
                              select
                              handleChange={(e) => {
                                onPrdChange(
                                  "repeatTask",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onPrdChange("noOfTimes", e?.target?.value, ind)
                              }
                              value={pl?.noOfTimes}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                !pl?.repeatTask
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomSelect
                              list={numberOfDaysList}
                              value={pl?.durationType}
                              select
                              handleChange={(e) => {
                                onPrdChange(
                                  "durationType",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onPrdChange("duration", e?.target?.value, ind)
                              }
                              value={pl?.duration}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                pl?.durationType === "Till Discharge"
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onPrdChange("startTime", e?.target?.value, ind)
                              }
                              value={pl?.startTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onPrdChange("endTime", e?.target?.value, ind)
                              }
                              value={pl?.endTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                !pl?.repeatTask
                              }
                            />
                          </div>
                          <div style={{ width: 250 }}>
                            {pl?.isAlreadyExists ? (
                              pl?.isDiscontinued ? (
                                <div className="flex-row-ali-cen">
                                  <div>
                                    <div>
                                      <CustomButton
                                        text="Discontinued"
                                        smallBtn
                                        grayBtn
                                        disabled
                                      />
                                    </div>
                                    <div>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated on:{" "}
                                        {moment(
                                          new Date(pl?.updatedDate)
                                        ).format("DD MMM YYYY, HH:mm")}
                                      </Typography>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated by:{" "}
                                        {getUserNameById(pl?.updatedUser)}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex-row-ali-cen h40">
                                  {/* <div
                                    className="cursor"
                                    onClick={() => onEdit(pl)}
                                  >
                                    <div className="flex-center">
                                      <EditIcon sx={plusBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div> */}
                                  <div className="ml15">
                                    <CustomButton
                                      text="Discontinue"
                                      smallBtn
                                      yellowBtn
                                      onClick={() => onDiscontinue(pl)}
                                    />
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="flex-row flex-center">
                                <img
                                  src={require("../../../../assets/images/png/delete.png")}
                                  alt=""
                                  className="imghw30 cursor mt5"
                                  onClick={() => deletePrdItem(ind)}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => onAddItem("procedure")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Card>
          <Card sx={cardSty} className="mt20">
            <div
              className="flex-row-ali-cen cursor"
              onClick={() =>
                handleOpenValues("adminster", !openValues?.adminster)
              }
            >
              {openValues?.adminster ? (
                <ArrowDropDownIcon sx={cardIcon} />
              ) : (
                <ArrowRightIcon sx={cardIcon} />
              )}
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs14 blue-color">
                  Administered
                </Typography>
              </div>
            </div>
            {openValues?.adminster ? (
              <div className="flex-column">
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <div style={{ minWidth: 1550 }}>
                    <div className="flex-row-ali-cen mh10">
                      <div style={{ width: 250 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Task <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Repeat Task?
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          No. of Times
                        </Typography>
                      </div>
                      <div style={{ width: 200 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration Type
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Start Time
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          End Time
                        </Typography>
                      </div>
                      <div style={{ width: 250 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {planList?.adminster?.map((pl, ind) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${ind}_adminster`}
                        >
                          <div className="pr10" style={{ width: 250 }}>
                            <CustomSelect
                              list={getAdministerList()}
                              value={pl?.task}
                              addNewSelect
                              handleChange={(e) => {
                                onAdmChange("task", e?.value ?? e, ind, {
                                  stockId: e?.stockId ?? null,
                                  serviceId: e?.serviceId ?? null,
                                });
                              }}
                              disabled={pl?.isAlreadyExists}
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomSelect
                              list={yesNoBoolList}
                              value={pl?.repeatTask}
                              select
                              handleChange={(e) => {
                                onAdmChange(
                                  "repeatTask",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                //  && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onAdmChange("noOfTimes", e?.target?.value, ind)
                              }
                              value={pl?.noOfTimes}
                              disabled={
                                !pl?.isEdit ||
                                //  && pl?.isAlreadyExists
                                !pl?.repeatTask
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomSelect
                              list={numberOfDaysList}
                              value={pl?.durationType}
                              select
                              handleChange={(e) => {
                                onAdmChange(
                                  "durationType",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onAdmChange("duration", e?.target?.value, ind)
                              }
                              value={pl?.duration}
                              disabled={
                                !pl?.isEdit ||
                                //  && pl?.isAlreadyExists
                                pl?.durationType === "Till Discharge"
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onAdmChange("startTime", e?.target?.value, ind)
                              }
                              value={pl?.startTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onAdmChange("endTime", e?.target?.value, ind)
                              }
                              value={pl?.endTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                !pl?.repeatTask
                              }
                            />
                          </div>
                          <div style={{ width: 250 }}>
                            {pl?.isAlreadyExists ? (
                              pl?.isDiscontinued ? (
                                <div className="flex-row-ali-cen">
                                  <div>
                                    <div>
                                      <CustomButton
                                        text="Discontinued"
                                        smallBtn
                                        grayBtn
                                        disabled
                                      />
                                    </div>
                                    <div>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated on:{" "}
                                        {moment(
                                          new Date(pl?.updatedDate)
                                        ).format("DD MMM YYYY, HH:mm")}
                                      </Typography>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated by:{" "}
                                        {getUserNameById(pl?.updatedUser)}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex-row-ali-cen h40">
                                  {/* <div
                                    className="cursor"
                                    onClick={() => onEdit(pl)}
                                  >
                                    <div className="flex-center">
                                      <EditIcon sx={plusBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div> */}
                                  <div className="ml15">
                                    <CustomButton
                                      text="Discontinue"
                                      smallBtn
                                      yellowBtn
                                      onClick={() => onDiscontinue(pl)}
                                    />
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="flex-row flex-center">
                                <img
                                  src={require("../../../../assets/images/png/delete.png")}
                                  alt=""
                                  className="imghw30 cursor mt5"
                                  onClick={() => deleteAdmItem(ind)}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => onAddItem("adminster")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Card>
          <Card sx={cardSty} className="mt20">
            <div
              className="flex-row-ali-cen cursor"
              onClick={() =>
                handleOpenValues("diagnostics", !openValues?.diagnostics)
              }
            >
              {openValues?.diagnostics ? (
                <ArrowDropDownIcon sx={cardIcon} />
              ) : (
                <ArrowRightIcon sx={cardIcon} />
              )}
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs14 blue-color">
                  Diagnostics
                </Typography>
              </div>
            </div>
            {openValues?.diagnostics ? (
              <div className="flex-column">
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <div style={{ minWidth: 1550 }}>
                    <div className="flex-row-ali-cen mh10">
                      <div style={{ width: 250 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Task <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 200 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Variant <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Repeat Task?
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          No. of Times
                        </Typography>
                      </div>
                      <div style={{ width: 200 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration Type
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Start Time
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          End Time
                        </Typography>
                      </div>
                      <div style={{ width: 250 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {planList?.diagnostics?.map((pl, ind) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${ind}_adminster`}
                        >
                          <div className="pr10" style={{ width: 250 }}>
                            <CustomSelect
                              list={getDiagnosticsList()}
                              value={pl?.task}
                              addNewSelect
                              handleChange={(e) => {
                                onDiagChange("task", e?.value ?? e, ind, {
                                  stockId: e?.stockId ?? null,
                                  serviceId: e?.serviceId ?? null,
                                });
                              }}
                              disabled={pl?.isAlreadyExists}
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomSelect
                              list={getVariantsByServiceId(pl?.serviceId)}
                              value={pl?.variant}
                              select
                              handleChange={(e) => {
                                onDiagChange("variant", e?.target?.value, ind);
                              }}
                              disabled={pl?.isAlreadyExists}
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomSelect
                              list={yesNoBoolList}
                              value={pl?.repeatTask}
                              select
                              handleChange={(e) => {
                                onDiagChange(
                                  "repeatTask",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onDiagChange("noOfTimes", e?.target?.value, ind)
                              }
                              value={pl?.noOfTimes}
                              type="number"
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                !pl?.repeatTask
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomSelect
                              list={numberOfDaysList}
                              value={pl?.durationType}
                              select
                              handleChange={(e) => {
                                onDiagChange(
                                  "durationType",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                //  && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onDiagChange("duration", e?.target?.value, ind)
                              }
                              value={pl?.duration}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                pl?.durationType === "Till Discharge"
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onDiagChange("startTime", e?.target?.value, ind)
                              }
                              value={pl?.startTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit
                                //  && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onDiagChange("endTime", e?.target?.value, ind)
                              }
                              value={pl?.endTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                !pl?.repeatTask
                              }
                            />
                          </div>
                          <div style={{ width: 250 }}>
                            {pl?.isAlreadyExists ? (
                              pl?.isDiscontinued ? (
                                <div className="flex-row-ali-cen">
                                  <div>
                                    <div>
                                      <CustomButton
                                        text="Discontinued"
                                        smallBtn
                                        grayBtn
                                        disabled
                                      />
                                    </div>
                                    <div>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated on:{" "}
                                        {moment(
                                          new Date(pl?.updatedDate)
                                        ).format("DD MMM YYYY, HH:mm")}
                                      </Typography>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated by:{" "}
                                        {getUserNameById(pl?.updatedUser)}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex-row-ali-cen h40">
                                  {/* <div className="cursor">
                                    <div
                                      className="flex-center"
                                      onClick={() => onEdit(pl)}
                                    >
                                      <EditIcon sx={plusBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div> */}
                                  <div className="ml15">
                                    <CustomButton
                                      text="Discontinue"
                                      smallBtn
                                      yellowBtn
                                      onClick={() => onDiscontinue(pl)}
                                    />
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="flex-row flex-center">
                                <img
                                  src={require("../../../../assets/images/png/delete.png")}
                                  alt=""
                                  className="imghw30 cursor mt5"
                                  onClick={() => deleteDiagItem(ind)}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => onAddItem("diagnostics")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Card>
          <Card sx={cardSty} className="mt20">
            <div
              className="flex-row-ali-cen cursor"
              onClick={() => handleOpenValues("others", !openValues?.others)}
            >
              {openValues?.others ? (
                <ArrowDropDownIcon sx={cardIcon} />
              ) : (
                <ArrowRightIcon sx={cardIcon} />
              )}
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs14 blue-color">
                  Others
                </Typography>
              </div>
            </div>
            {openValues?.others ? (
              <div className="flex-column">
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <div style={{ minWidth: 1450 }}>
                    <div className="flex-row-ali-cen mh10">
                      <div style={{ width: 250 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Task <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Repeat Task?
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          No. of Times
                        </Typography>
                      </div>
                      <div style={{ width: 200 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration Type
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Start Time
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          End Time
                        </Typography>
                      </div>
                      <div style={{ width: 250 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {planList?.others?.map((pl, ind) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${ind}_others`}
                        >
                          <div className="pr10" style={{ width: 250 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onOtherChange("task", e?.target?.value, ind)
                              }
                              value={pl?.task}
                              disabled={ind === 0 || pl?.isAlreadyExists}
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomSelect
                              list={yesNoBoolList}
                              value={pl?.repeatTask}
                              select
                              handleChange={(e) => {
                                onOtherChange(
                                  "repeatTask",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                //  && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onOtherChange(
                                  "noOfTimes",
                                  e?.target?.value,
                                  ind
                                )
                              }
                              value={pl?.noOfTimes}
                              disabled={
                                !pl?.isEdit && !pl?.repeatTask
                                //  ||
                                // pl?.isAlreadyExists
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomSelect
                              list={numberOfDaysList}
                              value={pl?.durationType}
                              select
                              handleChange={(e) => {
                                onOtherChange(
                                  "durationType",
                                  e?.target?.value,
                                  ind
                                );
                              }}
                              disabled={
                                !pl?.isEdit
                                // && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onOtherChange("duration", e?.target?.value, ind)
                              }
                              value={pl?.duration}
                              disabled={
                                !pl?.isEdit ||
                                // && pl?.isAlreadyExists
                                pl?.durationType === "Till Discharge"
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onOtherChange(
                                  "startTime",
                                  e?.target?.value,
                                  ind
                                )
                              }
                              value={pl?.startTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit
                                //  && pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                onOtherChange("endTime", e?.target?.value, ind)
                              }
                              value={pl?.endTime}
                              mobileTime
                              is12HourFomat={false}
                              disabled={
                                !pl?.isEdit && !pl?.repeatTask
                                //  ||
                                // pl?.isAlreadyExists
                              }
                            />
                          </div>
                          <div style={{ width: 250 }}>
                            {ind === 0 ? null : pl?.isAlreadyExists ? (
                              pl?.isDiscontinued ? (
                                <div className="flex-row-ali-cen">
                                  <div>
                                    <div>
                                      <CustomButton
                                        text="Discontinued"
                                        smallBtn
                                        grayBtn
                                        disabled
                                      />
                                    </div>
                                    <div>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated on:{" "}
                                        {moment(
                                          new Date(pl?.updatedDate)
                                        ).format("DD MMM YYYY, HH:mm")}
                                      </Typography>
                                      <Typography className="fs10 txt-regular black mt3 ml3">
                                        Updated by:{" "}
                                        {getUserNameById(pl?.updatedUser)}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex-row-ali-cen h40">
                                  {/* <div className="cursor">
                                    <div
                                      className="flex-center"
                                      onClick={() => onEdit(pl)}
                                    >
                                      <EditIcon sx={plusBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div> */}
                                  <div className="ml15">
                                    <CustomButton
                                      text="Discontinue"
                                      smallBtn
                                      yellowBtn
                                      onClick={() => onDiscontinue(pl)}
                                    />
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="flex-row flex-center">
                                <img
                                  src={require("../../../../assets/images/png/delete.png")}
                                  alt=""
                                  className="imghw30 cursor mt5"
                                  onClick={() => deleteOthetItem(ind)}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => onAddItem("others")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Card>
          <div className="flex-center mt10">
            <FormHelperText error>
              {planError ||
              (planList?.procedure?.length === 0 &&
                planList?.adminster?.length === 0 &&
                planList?.diagnostics?.length === 0 &&
                planList?.others?.length === 0)
                ? "Please add at least 1 record"
                : planList?.procedure?.some(isInvalidPlan) ||
                  planList?.adminster?.some(isInvalidPlan) ||
                  planList?.diagnostics?.some(isInvalidPlan) ||
                  planList?.others?.some(isInvalidPlan)
                ? "Please add valid records"
                : ""}
            </FormHelperText>
          </div>

          <div className="flex-center mt20">
            <div>
              <CustomButton text="Submit" onClick={handleSubmit} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={diagModVsble}
        onClose={handleModClose}
        header="Add"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={diagnosticTypes}
                value={diagValues?.type}
                error={diagnosticsErrors?.type}
                helperText={diagnosticsHelpers?.type}
                name="type"
                label={nameExpan?.["type"]}
                select
                handleChange={(e) => {
                  handleChangeValues("type", e?.target?.value);
                }}
                mandatoryField
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getDiagnosticsList()}
                value={diagValues?.testName}
                name="testName"
                label={nameExpan?.["testName"]}
                newSelect
                handleChange={(e) => {
                  handleChangeValues("testName", e?.value, {
                    price: e?.servicePrice ?? 0,
                    tax: e?.tax ?? 0,
                    serviceId: e?.serviceId ?? null,
                    doneAt: e?.doneAt,
                  });
                }}
                error={diagnosticsErrors?.testName}
                helperText={diagnosticsHelpers?.testName}
                mandatoryField
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getVariantsByServiceId(diagValues?.serviceId ?? null)}
                value={diagValues?.variant}
                name="variant"
                label={nameExpan?.["variant"]}
                newSelect
                handleChange={(e) => {
                  handleChangeValues("variant", e?.value, {
                    variantName: e?.variantName,
                    variantId: e?.value,
                  });
                }}
                error={diagnosticsErrors?.variant}
                helperText={diagnosticsHelpers?.variant}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Due Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="dueDate"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("dueDate", e?.target?.value)
                }
                value={diagValues?.dueDate}
                error={diagnosticsErrors?.dueDate}
                helperText={diagnosticsHelpers?.dueDate}
                mobileDate
                disabled={diagValues?.sampleCollected}
              />
            </Grid>
            {diagValues?.type === "Lab" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="font-medium fs14 gray7">
                  {nameExpan?.["sampleType"]}
                </div>
                <CustomTextField
                  value={getServiceDetById(diagValues?.serviceId)?.sampleType}
                  fullWidth
                  disabled
                />
              </Grid>
            )}
            {diagValues?.type === "Radiology" && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["modality"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.modality}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["device"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.device}
                    fullWidth
                    disabled
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={doneAtList}
                value={diagValues?.doneAt}
                error={diagnosticsErrors?.doneAt}
                helperText={diagnosticsHelpers?.doneAt}
                name="doneAt"
                label={nameExpan?.["doneAt"]}
                select
                handleChange={(e) => {
                  handleChangeValues("doneAt", e?.target?.value);
                }}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                {nameExpan?.["processingTime"]}
              </div>
              <CustomTextField
                value={
                  getServiceDetById(
                    diagValues?.serviceId,
                    diagValues?.variantId ?? null
                  )?.estimatedDuration ?? ""
                }
                fullWidth
                disabled
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="mtMin10"
            >
              <CustomCheckbox
                label="Sample Collected"
                checked={diagValues?.sampleCollected}
                onChange={() =>
                  handleChangeValues(
                    "sampleCollected",
                    !diagValues?.sampleCollected
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={priorityList}
                value={diagValues?.priority}
                error={diagnosticsErrors?.priority}
                helperText={diagnosticsHelpers?.priority}
                name="priority"
                label={nameExpan?.["priority"]}
                select
                handleChange={(e) => {
                  handleChangeValues("priority", e?.target?.value);
                }}
                mandatoryField
              />
            </Grid>
            {diagValues?.sampleCollected && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomTextField
                    name="collectionTime"
                    fullWidth
                    mobileTime
                    handleChange={(e) =>
                      handleChangeValues("collectionTime", e?.target?.value)
                    }
                    value={diagValues?.collectionTime}
                    error={diagnosticsErrors?.collectionTime}
                    helperText={diagnosticsHelpers?.collectionTime}
                    is12HourFomat={false}
                    label={nameExpan["collectionTime"]}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomSelect
                    list={diagStatusList}
                    value={diagValues?.status}
                    error={diagnosticsErrors?.status}
                    helperText={diagnosticsHelpers?.status}
                    name="status"
                    label={nameExpan?.["status"]}
                    select
                    handleChange={(e) => {
                      handleChangeValues("status", e?.target?.value);
                    }}
                    mandatoryField
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label={nameExpan?.["remarks"]}
                placeholder="Remarks"
                name="remarks"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("remarks", e?.target?.value)
                }
                value={diagValues?.remarks}
                error={diagnosticsErrors?.remarks}
                helperText={diagnosticsHelpers?.remarks}
                multiline
              />
            </Grid>

            {diagValues?.files?.length > 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FilesWithCloseButton
                  files={diagValues?.files}
                  onClickFile={(i, file) => handleImageRemove(i)}
                />
              </Grid>
            ) : null}
            {diagValues?.sampleCollected ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomUpload
                  onUploadFile={onUploadFile}
                  multipleNew
                  multiFiles
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-center">
                <div>
                  <CustomButton text="Submit" smallBtn onClick={onSaveDiag} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={patOtherModVsble}
        onClose={onClosePatOtherMod}
        header="Patient Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomTextField
                label={nameExpan?.["description"]}
                placeholder="Description"
                name="description"
                fullWidth
                handleChange={(e) =>
                  handleChangeValuesPatOther("description", e?.target?.value)
                }
                value={patOtherValues?.description}
                // error={diagnosticsErrors?.description}
                // helperText={diagnosticsHelpers?.description}
                multiline
              />
            </Grid>

            {patOtherValues?.files?.length > 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FilesWithCloseButton
                  files={patOtherValues?.files}
                  onClickFile={(i, file) => handleImageOtherPatRemove(i)}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomUpload
                onUploadFile={onUploadFilePatOther}
                multipleNew
                multiFiles
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-center">
                <div>
                  <CustomButton
                    text="Submit"
                    smallBtn
                    onClick={onSavePatOther}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={warnModVsble}
        onClose={() => setWarnModVsble(false)}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-row">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Please add atleast one procedure before making an administration
          </Typography>
          <div className="flex1-end mtMin75">
            <IconButton
              aria-label="close"
              onClick={() => setWarnModVsble(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admUpdteModVsble}
        onClose={onCloseAdmUpdteMod}
        header="Administer"
        rightModal
        modalWidth={30}
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Name</div>
              <CustomSelect
                list={getAdministerList()}
                value={adminValues?.name}
                addNewSelect
                mandatoryField
                handleChange={(e) => {
                  onChangeAdminModValue("name", e?.value ?? e, {
                    stockId: e?.stockId ?? null,
                    serviceId: e?.serviceId ?? null,
                    type: e?.type,
                  });
                }}
                plusBtn
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Batch Number</div>
              <CustomSelect
                list={getBatches(adminValues?.stockId)}
                value={adminValues?.batchNumber}
                handleChange={(e, value) => {
                  onChangeAdminModValue("batchNumber", value);
                }}
                search
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Dosage</div>
              <CustomTextField
                fullWidth
                handleChange={(e) =>
                  onChangeAdminModValue("dosage", e?.target?.value)
                }
                value={adminValues?.dosage}
                suffix={
                  getRightPackageUom(
                    getBatch(
                      adminValues?.stockId,
                      adminValues?.batchNumber?.value ?? adminValues?.batchId
                    )?.packageUom
                  )?.length > 0 ? (
                    <Custom3dotString
                      str={`${getRightPackageUom(
                        getBatch(
                          adminValues?.stockId,
                          adminValues?.batchNumber?.value ??
                            adminValues?.batchId
                        )?.packageUom
                      )}`}
                      length={9}
                      className="fs12 font-medium"
                    />
                  ) : (
                    ""
                  )
                }
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Route</div>
              <CustomSelect
                list={routeList}
                value={adminValues?.route}
                search
                handleChange={(e, value) => {
                  onChangeAdminModValue("route", value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {adminValues?.files?.length > 0 ? (
                <FilesWithCloseButton
                  files={adminValues?.files}
                  onClickFile={(i, file) => handleAdmImageRemove(i)}
                />
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomUpload
                onUploadFile={onUploadAdmFile}
                multipleNew
                multiFiles
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Schedule for the next dosage?
              </div>
              <CustomCheckbox
                radio
                name="nextDosage"
                onChange={(e) =>
                  onChangeAdminModValue("nextDosage", e?.target?.value)
                }
                radios={radioYesNoList}
                defaultValue={adminValues?.nextDosage ?? "No"}
              />
            </Grid>
            {adminValues?.nextDosage === "Yes" ? (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="mtMin15"
              >
                <div className="txt-semi-bold fs14 light-grey">
                  Next Due Date
                </div>
                <CustomTextField
                  name="nextDueDate"
                  fullWidth
                  handleChange={(e) =>
                    onChangeAdminModValue("nextDueDate", e?.target?.value)
                  }
                  value={adminValues?.nextDueDate ?? datePlusOneDay}
                  mobileDate
                  minDate={datePlusOneDay}
                />
              </Grid>
            ) : null}
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Save" smallBtn onClick={onSaveAdminValues} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={remarksModVsble}
        onClose={onCloseRemarksMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomTextField
            value={remarks}
            handleChange={(e) => setRemarks(e?.target?.value)}
            multiline
            fullWidth
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton text="Save" smallBtn onClick={onSaveRemarks} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={discontinueModVsble}
        onClose={onCloseDiscontinueMod}
        header="Discontinue"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to discontinue the task?
        </Typography>

        <div className="flex-center mv20">
          <div className="mr10">
            <CustomButton
              text="Yes"
              redBtn
              onClick={onConfirmDiscontinue}
              smallBtn
            />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDiscontinueMod} smallBtn />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default InpatientTasks;
